<kui-button-group size="sm">
    @for (button of radioValues; track button) {
        <button kui-button (click)="changeValue(button.id)" [color]="selected === button.id ? 'primary' : 'secondary'">
            {{ button.value }}
        </button>
    }
</kui-button-group>
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
